import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ValueProp from './components/ValueProp';
import BeforeAfter from './components/BeforeAfter';
import PriceComparison from './components/PriceComparison';
import Features from './components/Features';
import Waitlist from './components/Waitlist';
import ServiceComparison from './components/ServiceComparison';

function App() {
  return (
    <>
      <div className="flex flex-col min-h-screen overflow-x-hidden w-full">
        <Header />
        <main className="flex-grow overflow-x-hidden">
          <Hero />
          <ValueProp />
          <PriceComparison />
          <Features />
          <ServiceComparison />
          <BeforeAfter />
          <Waitlist />
        </main>
      </div>
    </>
  );
}

export default App;
